import React from 'react';
import PropTypes from 'prop-types';

import ElementReactions from '../reactions/ElementReactions';

const CommentReactions = ({ _id, content, ...rest }) => (
    <ElementReactions {...rest} elementId={_id} reactions={content && content.get('reactions')} />
);

CommentReactions.propTypes = {
    _id: PropTypes.string,
    content: PropTypes.object,
};

export default CommentReactions;
